import React, { useState } from 'react';
import { Dialog } from '../ui/Dialog';
import { Search } from 'lucide-react';
import './CommandPalette.css';

export interface CommandItem {
  id: string;
  title: string;
  category?: string;
  onSelect: () => void;
}

export interface CommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  items?: CommandItem[];
}

export const CommandPalette: React.FC<CommandPaletteProps> = ({
  open,
  onOpenChange,
  items = [],
}) => {
  const [query, setQuery] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);

  const filtered = items.filter((it) =>
    it.title.toLowerCase().includes(query.toLowerCase()),
  );

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelectedIndex((i) => (filtered.length ? (i + 1) % filtered.length : 0));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelectedIndex((i) =>
        filtered.length ? (i - 1 + filtered.length) % filtered.length : 0,
      );
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (filtered[selectedIndex]) {
        filtered[selectedIndex].onSelect();
        onOpenChange(false);
      }
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange} title="Quick Navigation">
      <div className="sedlex-cmd-palette">
        <div className="sedlex-cmd-search">
          <Search aria-hidden="true" />
          <input
            type="text"
            className="sedlex-cmd-input"
            placeholder="Jump to a page or statutory family…"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              setSelectedIndex(0);
            }}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="sedlex-cmd-list">
          {filtered.length === 0 ? (
            <div className="sedlex-cmd-empty">No results found</div>
          ) : (
            filtered.map((item, idx) => (
              <button
                key={item.id}
                type="button"
                className={`sedlex-cmd-item ${idx === selectedIndex ? 'is-selected' : ''}`}
                onClick={() => {
                  item.onSelect();
                  onOpenChange(false);
                }}
              >
                <span className="sedlex-cmd-title">{item.title}</span>
                {item.category && <span className="sedlex-cmd-cat">{item.category}</span>}
              </button>
            ))
          )}
        </div>
      </div>
    </Dialog>
  );
};
